import template from './trip-ucl-terms.html';

const DIRECTIVE_NAME = TripUclTerms.DIRECTIVE_NAME = 'ktTripUclTerms';
export default function TripUclTerms() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: TripUclTermsController,
        controllerAs: '$ctrl',
        scope: {
            doesUserAgreeWithUclTerms: `=${DIRECTIVE_NAME}`,
            tripData: `=${DIRECTIVE_NAME}TripData`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function TripUclTermsController() {
    const vm = this;

    Object.assign(vm, {
        $onInit,
        isAllCheckboxTermsAndConditionsChecked,
    });

    function $onInit() {
        vm.doesUserAgreeWithUclTerms = !doesTermsAndConditionsHasRequiredPoint();
        vm.checkboxes = [];
    }
    function doesTermsAndConditionsHasRequiredPoint() {
        return vm.tripData
            && vm.tripData.TermsAndConditionsConfiguration
            && vm.tripData.TermsAndConditionsConfiguration.Sections
            && vm.tripData.TermsAndConditionsConfiguration.Sections
                .some(({IsRequired}) => IsRequired);
    }

    function isAllCheckboxTermsAndConditionsChecked() {
        vm.doesUserAgreeWithUclTerms = vm.checkboxes.every((item) => item);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-ucl-terms/trip-ucl-terms-component.js